<div class="progress-wrapper">
  <div class="progress" [ngStyle]="{width: progressPerc+'%'}"></div>
</div>
